import axios from "src/utils/axios"
import { store } from "src/redux/stores/store"

const base = conjuntoId => `contifico/conjuntos/${conjuntoId}`

export const getCredencialesContifico = async conjuntoId =>
  (await axios.get(`${base(conjuntoId)}/credenciales/`)).data

export const saveCredencialesContifico = async (conjuntoId, data) =>
  (await axios.put(`${base(conjuntoId)}/credenciales/`, data)).data

export const getCatalogoContifico = async (conjuntoId, refrescar = false) =>
  (
    await axios.get(`${base(conjuntoId)}/catalogo/`, {
      params: refrescar ? { refrescar: 1 } : {},
    })
  ).data

export const getMapeoContifico = async conjuntoId =>
  (await axios.get(`${base(conjuntoId)}/mapeo/`)).data

export const saveMapeoContifico = async (conjuntoId, mapeo) =>
  (await axios.put(`${base(conjuntoId)}/mapeo/`, mapeo)).data

export const getDocumentosContifico = async (conjuntoId, params) =>
  (await axios.get(`${base(conjuntoId)}/documentos/`, { params })).data

export const buscarProductosContifico = async (conjuntoId, q) =>
  (await axios.get(`${base(conjuntoId)}/productos/`, { params: { q } })).data

export const importarRubrosContifico = async (conjuntoId, modo) =>
  (await axios.post(`${base(conjuntoId)}/importar-rubros/`, { modo })).data

export const sincronizarContifico = async (conjuntoId, data = {}) =>
  (await axios.post(`${base(conjuntoId)}/sincronizar/`, data)).data

/**
 * Envia a Contifico el ingreso/egreso recien guardado, anulado o eliminado.
 * Se usa encadenado a la escritura en Firestore:
 *   ref.add(data).then(trackContifico(conjuntoId, "ingreso"))
 *   ref.doc(id).update(data).then(trackContifico(conjuntoId, "egreso", id))
 * No bloquea el guardado ni muestra avisos: el backend deja el resultado en el
 * campo Contifico del documento, que la tabla muestra en un tooltip.
 */
export const trackContifico = (conjuntoId, tipo, documentoId) => result => {
  const { complex } = store.getState()
  const id = documentoId || result?.id
  // Algunos servicios escriben en el conjunto activo sin recibir su id
  const conjunto = conjuntoId || complex?.complex?.id
  if (complex?.modules?.Contifico && conjunto && id) {
    sincronizarContifico(conjunto, { tipo, documento_id: id }).catch(() => {})
  }
  return result
}

// Para escrituras con id generado: ref.doc().set(data) no devuelve el id
export const setTracked = (ref, data, tipo, conjuntoId) =>
  ref.set(data).then(trackContifico(conjuntoId, tipo, ref.id))

// Mensaje legible de un error de DRF ({detail}, {campo: [..]} o [..])
export const contificoErrorMessage = (error, fallback) => {
  const data = error?.response?.data
  if (!data) return fallback
  if (typeof data.detail === "string") return data.detail
  const first = Object.values(data).flat()[0]
  return typeof first === "string" ? first : fallback
}
